var exports = {
  "IH": "SettingsModalHeader.module__bannerContent___bTU5Mn",
  "lt": "SettingsModalHeader.module__bannerTextContainer___bTU5Mn",
  "_M": "SettingsModalHeader.module__bannerText___bTU5Mn",
  "WP": "SettingsModalHeader.module__bannerTextFlash___bTU5Mn",
  "tD": "SettingsModalHeader.module__bannerTextNormal___bTU5Mn",
  "gG": "SettingsModalHeader.module__bannerActions___bTU5Mn",
  "ki": "SettingsModalHeader.module__titleContent___bTU5Mn",
  "oB": "SettingsModalHeader.module__titleWrapper___bTU5Mn",
  "DD": "SettingsModalHeader.module__title___bTU5Mn",
  "Kk": "SettingsModalHeader.module__icon___bTU5Mn",
  "vU": "SettingsModalHeader.module__headerTransition___bTU5Mn",
};

module.exports = exports;
